import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
connectedCallback() {
  super.connectedCallback();
  this.#restoreSavedLayout();
  
  // ✅ راقب تغيير الـ grid
  const observer = new MutationObserver(() => {
    const { grid } = this.refs;
    if (!grid) return;
    
    const currentView = grid.getAttribute('product-grid-view');
    const currentSize = grid.getAttribute('data-product-card-size');
    
    // ✅ حدّث الأيقونة حسب الوضع الفعلي
    if (currentSize === 'small' && currentView !== 'zoom-out') {
      // لو الشبكة small بس الـ view مش zoom-out، غيّر لـ zoom-out
      const zoomOutInput = this.querySelector('input[value="zoom-out"]');
      if (zoomOutInput) zoomOutInput.checked = true;
    } else if (currentSize === 'medium' && currentView !== 'default') {
      // لو الشبكة medium بس الـ view مش default، غيّر لـ default
      const defaultInput = this.querySelector('input[value="default"]');
      if (defaultInput) defaultInput.checked = true;
    }
  });
  
  if (this.refs.grid) {
    observer.observe(this.refs.grid, { attributes: true, attributeFilter: ['data-product-card-size', 'product-grid-view'] });
  }
  
  mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
  this.setAttribute('initialized', '');
}

  /**
   * Restores the saved layout from localStorage
   */
#restoreSavedLayout() {
  const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
  const savedLayout = localStorage.getItem(`product-grid-view-${viewport}`) || 'zoom-out';
  
  const { grid } = this.refs;
  if (grid) {
    // ✅ استخدم نفس الـ animation اللي بتصير لما تضغط الأيقونة
   this.#setLayout(savedLayout); // بدون View Transition عند التحميل

  }
  
  const targetInput = this.querySelector(`input[value="${savedLayout}"]`);
  if (targetInput instanceof HTMLInputElement) {
    targetInput.checked = true;
  }
}

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      localStorage.setItem(`product-grid-view-${viewport}`, value); // تغيير من sessionStorage لـ localStorage
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    
    // خلي الـ view كما هو
    grid.setAttribute('product-grid-view', value);
    
    // لو zoom-out، غيّر لـ small
    if (value === 'zoom-out') {
      grid.setAttribute('data-product-card-size', 'small');
      
      // احذف أي CSS قديم
      grid.style.setProperty('--product-grid-columns-desktop', 'repeat(auto-fill, minmax(180px, 1fr))');
    } else {
      grid.setAttribute('data-product-card-size', 'medium');
      grid.style.removeProperty('--product-grid-columns-desktop');
    }
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
